import { ref } from 'vue'
import Polling from '@app/utils/polling'

type RefreshFunctionType = () => boolean

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
interface UseSfPollingInterface<ReturnFunctionType extends Function> {
  startPolling: (
    channel: string,
    lastMessagebusId: number,
    refreshCondition: RefreshFunctionType,
    returnFunction: ReturnFunctionType
  ) => () => void
}

export default function useSfPolling<
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  ReturnFunctionType extends Function
>(): UseSfPollingInterface<ReturnFunctionType> {
  const started = ref(false)

  function start(pollingClass: Polling<ReturnFunctionType>): void {
    if (!started.value) {
      started.value = true
      pollingClass.subscribe()
    }
  }

  function stop(pollingClass: Polling<ReturnFunctionType>): void {
    if (started.value) {
      started.value = false
      pollingClass.unsubscribe()
    }
  }

  function startPolling(
    channel: string,
    lastMessagebusId: number,
    refreshCondition: RefreshFunctionType,
    returnFunction: ReturnFunctionType
  ): () => void {
    const pollingClass: Polling<ReturnFunctionType> = new Polling(
      channel,
      lastMessagebusId,
      returnFunction
    )

    if (refreshCondition()) {
      start(pollingClass)
    } else {
      stop(pollingClass)
    }

    return () => stop(pollingClass)
  }

  return {
    startPolling,
  }
}
